import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { GetHelpZendeskSellerPopularArticles } from './GetHelpZendeskSellerPopularArticles.tsx';
import { GetHelpZendeskBrowseByTopic } from './GetHelpZendeskBrowseByTopic.tsx';
import { GetHelpZendeskSellerItemTile } from './GetHelpZendeskSellerItemTile.tsx';
import { type GetHelpZendeskSellerItem_viewer$key } from './__generated__/GetHelpZendeskSellerItem_viewer.graphql.ts';

import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment GetHelpZendeskSellerItem_viewer on Viewer {
        ...GetHelpZendeskSellerItemTile_viewer
        ...GetHelpZendeskBrowseByTopic_viewer
        ...GetHelpZendeskSellerPopularArticles_viewer
    }
`;

const GetHelpZendeskSellerItem: FC<{ viewer: GetHelpZendeskSellerItem_viewer$key }> = ({
    viewer: viewerRef,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);

    return (
        <>
            <GetHelpZendeskSellerItemTile viewer={viewer} />
            <div className={dibsCss.mtMedium}>
                <GetHelpZendeskSellerPopularArticles viewer={viewer} />
            </div>
            <div className={dibsCss.mtMedium}>
                <GetHelpZendeskBrowseByTopic viewer={viewer} />
            </div>
        </>
    );
};

export { GetHelpZendeskSellerItem };
